import React, { useState } from "react";
import { Link } from "react-router-dom";

const PreviousFiles = ({
  prevfiles,
  handleDownload,
  handleFileDelete,
  process,
  downloadingFile,
  preview,
  handlePreview,
}) => {
  return (
    <div className="w-full">
      {prevfiles?.length > 0 && (
        <div className="">
          <div className="w-full flex justify-start">
            <h1 className="text-24 font-semibold">Previous Files</h1>
          </div>
          <div className=" rounded-[16px] border-[1px] border-commonborder shadow-commonshadow mt-10 overflow-auto max-h-[600px]">
            <table className="w-full">
              <thead className="sticky top-0 z-10 bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold w-full">
                <tr>
                  <th className="px-4 py-5">S.No</th>
                  <th className="px-4 py-5">File Name</th>
                  <th className="px-4 py-5">File Uploaded on</th>
                  {preview ? <th className="px-4 py-5">Preview File</th> : ""}
                  <th className="px-4 py-5">Download Report</th>
                  {/* <th className="px-4 py-5">Status</th> */}
                  <th className="px-4 py-5">Delete</th>
                </tr>
              </thead>
              <tbody className="w-full text-left bg-white">
                {prevfiles.map((files, i) => (
                  <tr
                    key={i}
                    className="border-b-[1px] border-commonborder last:border-none"
                  >
                    <td className="px-4 py-5">{i + 1}</td>
                    <td className="px-4 py-5">{files.file_name}</td>
                    <td className="px-4 py-5">{files.date}</td>
                    {preview ? (
                      <td className="px-4 py-5">
                        <Link
                          to={`/preview/${files.uuid}`}
                          target="_"
                        >
                          <p
                            className={`${
                              files.file_status === "0"
                                ? "text-highlight"
                                : "text-highlight opacity-[100%]"
                            }`}
                          >
                            Preview
                          </p>
                        </Link>
                      </td>
                    ) : (
                      ""
                    )}
                    <td className="px-4 py-5">
                      {files.status === "3" ? (
                        <p className="text-red-500">"Failed"</p>
                      ) : (
                        <button
                          className=""
                          disabled={downloadingFile === files.uuid}
                          onClick={() => handleDownload(files.uuid, process)}
                        >
                          <p
                            className={`${
                              files.status === "0"
                                ? "text-highlight"
                                : "text-highlight opacity-[100%]"
                            }`}
                          >
                            {files.status === "1"
                              ? "processing..."
                              : downloadingFile?.includes(files.uuid) &&
                                (files.status === "2" || files.status == "0")
                              ? "Downloading..."
                              : "Download"}
                          </p>
                        </button>
                      )}
                    </td>
                    {/* <td className="px-4 py-5">
                      <div
                        className={`w-fit px-4 py-1 rounded-[12px] text-white font-regular ${
                          files.file_status === "0"
                            ? "bg-highlight"
                            : files.file_status === "1"
                            ? "bg-[#008000]"
                            : "bg-[#f89611]"
                        }`}
                      >
                        {files.file_status === "0" ? (
                          <button className="py-1" onClick={""}>
                            {`Resume ${files.resume_process}`}
                          </button>
                        ) : files.file_status === "1" ? (
                          <div className="py-1">Completed</div>
                        ) : (
                          <div className="py-1">Processing...</div>
                        )}
                      </div>
                    </td> */}
                    <td className="px-4 py-5">
                      <button
                        onClick={() =>
                          handleFileDelete(files.uuid, files.file_name)
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="red"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                        >
                          <path
                            stroke="none"
                            d="M0 0h24v24H0z"
                            fill="none"
                          />
                          <path d="M4 7l16 0" />
                          <path d="M10 11l0 6" />
                          <path d="M14 11l0 6" />
                          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* {prevfiles.map((files, i) => (
                  <div
                    key={i}
                    className="w-full max-h-[500px] overflow-auto mt-6 bg-white overflow-hidden rounded-[12px]"
                  >
                    <div className="p-6 border-[1px] border-C4C6CC rounded-[12px] bg-F8F9FA">
                      <div className="border-[1px] border-highlight border-dashed py-4 flex flex-col justify-center w-full items-center rounded-[16px]">
                        <div className="flex w-full px-4 items-center justify-between">
                          <div className="flex items-center justify-between gap-4">
                            <span className="w-8 h-8">
                              <img
                                alt="epub_logo"
                                src={
                                  process.env.PUBLIC_URL + "/images/epub.svg"
                                }
                                className="w-full h-full object-cover"
                              ></img>
                            </span>
                            <div className="flex flex-col items-start">
                              <p>{files.file_name}</p>
                            </div>
                          </div>
                          <div className="flex gap-5">
                            {files.file_status === "1" && (
                              <button
                                onClick={() => handleDownload(files.file_id)}
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/images/downloadicon.svg"
                                  }
                                  alt="download"
                                ></img>
                              </button>
                            )}
                          <div
                            className={`w-fit px-4 py-1 rounded-[4px] text-white font-semibold ${
                              files.file_status === "0"
                                ? "bg-highlight"
                                : "bg-[#008000]"
                            }`}
                          >
                              <button
                                onClick={
                                  files.file_status === "0"
                                    ? () => handleFileNav(files)
                                    : undefined
                                }
                              >
                              {files.file_status === "0"
                                ? "Resume Processing"
                                : "Completed"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                ))} */}
        </div>
      )}
    </div>
  );
};

export default PreviousFiles;
